const VALID_LANGUAGES = ['hi', 'pa'];

/**
 * Current UI language from URL or localStorage ('en' | 'hi' | 'pa')
 */
export function getCurrentLanguage() {
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  if (pathParts.length > 0 && VALID_LANGUAGES.includes(pathParts[0])) {
    return pathParts[0];
  }
  const stored = localStorage.getItem('language');
  if (stored && VALID_LANGUAGES.includes(stored)) {
    return stored;
  }
  return 'en';
}

/**
 * Build a path with language prefix when needed.
 * e.g. getLocalizedPath('myaccount') -> '/hi/myaccount' or '/myaccount'
 */
export function getLocalizedPath(path) {
  const clean = String(path || '').replace(/^\//, '');
  const lang = getCurrentLanguage();
  if (lang !== 'en') {
    return `/${lang}/${clean}`;
  }
  return `/${clean}`;
}

export function isSignInPath(pathname = window.location.pathname) {
  return (
    pathname === '/signin' ||
    pathname === '/signin/' ||
    pathname === '/hi/signin' ||
    pathname === '/hi/signin/' ||
    pathname === '/pa/signin' ||
    pathname === '/pa/signin/'
  );
}
